
import "../../vips/css/components/priority-messages.less";

(function () {
    var portDebug = false;
    var priorityMessageKey = "VIPs-PriorityMessages";
    var notificationMenuItemCss = "notification-menu-item";

    init();
    initEvents();

    function log(message, object = null) {
        if (!portDebug) {
            return;
        }

        if (message !== null) {
            console.log(message);
        }

        if (object !== null) {
            console.log(object);
        }
    }

    function init() {

        // check the session
        var messages = getMessagesFromStorage();
        // if no messsages set yet, get from DOM
        if (messages == null) {
            log("messages is null, setting from DOM");

            messages = getMessagesFromDOM();
            setMessages(messages);
            displayMessages();
            displayCount(messages);

            return;
        }

        log("messages are not null, getting the rest", messages);

        // if messages have already been set, 
        // get current messages from DOM
        // get messages from cookie
        // compare to get all messages not yet hidden (Display=false)
        var messagesFromDOM = getMessagesFromDOM();

        log("messages from DOM", messagesFromDOM);

        var activeMessages = compare(messagesFromDOM, messages);

        setMessages(activeMessages);
        displayMessages();
        displayCount(messagesFromDOM);
    }

    function displayCount(messagesFromDOM) {
        //update the count icon for all messages
        var count = messagesFromDOM.length > 0 ? messagesFromDOM.length : 0;

        log("message count = " + count);

        if (count === 0) {
            return;
        }

        var notificationIcons = document.getElementsByClassName(notificationMenuItemCss);

        for (var i = 0; i < notificationIcons.length; i++) {

            notificationIcons[i].classList.add("active");
            notificationIcons[i].getElementsByClassName("notification-count")[0].innerText = count;

        }
    }

    function displayMessages() {
        var messages = getMessagesFromStorage();
        var activeMessages = getActive(messages);
        if (activeMessages === undefined || activeMessages.length == 0) {
            return;
        }

        log("displaying messages " + activeMessages.length);

        for (var i = 0; i < activeMessages.length; i++) {
            show(activeMessages[i].Id);
        }
    }

    function initCloseButtons() {
        var closeBtns = document.getElementsByClassName("priority-message-close");

        for (var i = 0; i < closeBtns.length; i++) {
            closeBtns[i].addEventListener('click', function () {
                var id = this.getAttribute("data-id");
                hide(id);
            }, false);
        }
    }

    function initShowHideButton() {
        var showHideBtns = document.getElementsByClassName(notificationMenuItemCss);

        log("init show hide button for elements", showHideBtns);

        // get all messages - if any, add class "show" to menu
        var allMessages = getMessagesFromStorage();
        var messages = getActive(allMessages);
        var showMenuItem = false;

        log("initShowHideButton - next, messages = ", messages);

        if (allMessages.length > 0) {
            showMenuItem = true;
        }

        for (var i = 0; i < showHideBtns.length; i++) {
            var showHideBtn = showHideBtns[i];

            log("individual show hide button", showHideBtn);

            if (showMenuItem) {
                showHideBtn.classList.add("show");
            }

            showHideBtn.addEventListener('click', function (e) {
                // make decision about whether to show or hide
                // if none are visible, show all
                // if 1 is visible
                e.preventDefault();
                e.stopPropagation();
                

                log("click event, messages", messages);

                if (messages.length > 0) {
                    log("showing " + messages.length + " active messages");
                    // if there is more than 1 message showing, close them
                    // if there is only 1 message showing, see if there are more than 1 total
                    // if more than 1 total, and only one showing, show the others
                    // if only 1 total and one showing, close it
                    if (messages.length > 1) {
                        log("more than 1 message");
                        // more than one showing, close all
                        for (var j = 0; j < messages.length; j++) {
                            hide(messages[j].Id);
                        }
                    } else {
                        // only 1 showing - if more others, show them
                        log("only showing 1 message");
                        if (allMessages.length > 1) {
                            // more than one total message, so showing the others
                            for (var j = 0; j < allMessages.length; j++) {
                                show(allMessages[j].Id);
                            }
                        } else {
                            show(messages[0].Id);
                        }
                    }

                } else {
                    log("no active message, showing all");
                    showAllMessages();
                }
            })
        }

    }

    function showAllMessages() {
        var messages = getMessagesFromStorage();
        log("showing all messages", messages);

        for (var i = 0; i < messages.length; i++) {
            show(messages[i].Id);
        }
    }

    function initEvents() {
        initCloseButtons();
        initShowHideButton();
    }

    function getMessage(id) {
        var message = document.querySelectorAll('.priority-message[data-id="' + id + '"]')[0];

        log("getting message by id - " + id, message);

        return message;
    }

    function show(id) {

        var elem = getMessage(id);

        if (elem === null || elem === undefined) {
            return;
        }

        log("showing message for id " + id, elem);

        elem.classList.add("active");

        updateMessageStatus(id, true);
    }

    function hide(id) {
        var elem = getMessage(id);

        if (elem === null || elem === undefined) {
            return;
        }

        log("hiding message for id " + id, elem);

        elem.classList.remove("active");

        updateMessageStatus(id, false);
    }

    function compare(messagesFromDOM, messagesFromStorage) {
        // message from DOM are all active by default Display=true
        // messages from storage have previous settings "Display=true/false"
        // goal is to combine objects to get the intersection
        //var final = Object.assign({}, messagesFromDOM, messagesFromStorage);
        var final = [];
        for (var i = 0; i < messagesFromDOM.length; i++) {
            var message = messagesFromDOM[i];
            var found = false;

            for (var j = 0; j < messagesFromStorage.length; j++) {
                var storedMessage = messagesFromStorage[j];

                if (storedMessage.Id === message.Id) {
                    final.push(storedMessage);
                    found = true;
                }
            }

            if (!found) {
                final.push(message);
            }
        }

        log("final compared object", final);

        return final;
    }

    function getActive(messages) {

        var allMessages = [];

        for (var i = 0; i < messages.length; i++) {
            allMessages.push(messages[i]);
        }

        log("filtering active " + allMessages.length, allMessages);

        var active = allMessages.map(function (message) {
            if (message.Display === true) {
                return message;
            }
            return undefined;
        }).filter(function (message) {
            return message !== undefined;
        }).map(function (message) { return message });

        log("active messages", active);

        return active;
    }

    function getMessagesFromDOM() {
        var current = document.getElementsByClassName("priority-message");
        var messages = [];
        for (var i = 0; i < current.length; i++) {
            var id = current[i].getAttribute("data-id");

            log("current id = " + id);

            var obj = { Id: id, Display: true };
            messages.push(obj);
        }

        return messages;
    }

    function setMessages(messages) {

        log("Setting Messages", messages);

        var myData = Object.keys(messages).map(key => {
            return messages[key];
        })

        localStorage.setItem(priorityMessageKey, JSON.stringify(myData));
    }

    function updateMessageStatus(id, display) {

        log("Updating message status for Id = " + id + ", changing display to " + display);

        var messages = getMessagesFromStorage();
        var newMessages = [];
        for (var i = 0; i < messages.length; i++) {
            var message = messages[i];
            if (message.Id == id) {
                message.Display = display;
            }
            newMessages.push(message);
        }

        setMessages(newMessages);
    }

    function getMessagesFromStorage() {

        var messages = JSON.parse(localStorage.getItem(priorityMessageKey));

        log("getting messages from storage", messages);

        return messages;
    }

})();
